import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import advisoryReducer from '../features/advisory/advisorySlice';
import teamReducer from '../features/team/teamSlice';
import newsReducer from "../features/news/newsSlice";
import galleryReducer from "../features/gallery/gallerySlice";
import homeReducer from "../features/home/homeSlice";
import { createLogger } from "redux-logger";

const logger = createLogger();

const store = configureStore({
    reducer : {
        advisory : advisoryReducer,
        team : teamReducer,
        news : newsReducer,
        gallery: galleryReducer,
        home : homeReducer,
    },
    middleware : (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export default store;